// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__39DjS","clinicsSelect":"TableHeading_clinicsSelect__1GVTc"};